<template>
	<div>
		<v-btn
			flat
			color="success"
			@click="$refs.upload.click()"
			>{{buttonText}}</v-btn>
		<input type="file" style="display : none" ref="upload" @change="check" accept="image/*">
	</div>
</template>

<script>
import firebase from 'firebase'
export default {
	data(){
		return {
			buttonText : "SELECT FILE",
			finalFile : null,
		}
	},
	props : {
		maxSize : Number,
	},
	methods : {
		check(e){
			var vm = this;
			var file = e.target.files[0];
			if (file==undefined){
				vm.text = "";
				vm.buttonText = "SELECT FILE";
				vm.finalFile = null;
			}
			else {
				if(file.size>vm.maxSize){
					vm.finalFile = null;
					vm.buttonText = "SIZE EXCEEDED (200KB)"
				}
				else {
					vm.finalFile = file;
					vm.buttonText="FILE CHOSEN";
				}
			}
			vm.$emit("fileChosen",vm.finalFile);
		},
	},
};
</script>